export const distritos = [
  { cod_distrito: "19", nome_distrito: "ANGRA DO HEROISMO" },
  { cod_distrito: "01", nome_distrito: "AVEIRO" },
  { cod_distrito: "02", nome_distrito: "BEJA" },
  { cod_distrito: "03", nome_distrito: "BRAGA" },
  { cod_distrito: "04", nome_distrito: "BRAGANCA" },
  { cod_distrito: "05", nome_distrito: "C BRANCO" },
  { cod_distrito: "06", nome_distrito: "COIMBRA" },
  { cod_distrito: "07", nome_distrito: "EVORA" },
  { cod_distrito: "08", nome_distrito: "FARO" },
  { cod_distrito: "22", nome_distrito: "FUNCHAL" },
  { cod_distrito: "09", nome_distrito: "GUARDA" },
  { cod_distrito: "20", nome_distrito: "HORTA" },
  { cod_distrito: "10", nome_distrito: "LEIRIA" },
  { cod_distrito: "11", nome_distrito: "LISBOA" },
  { cod_distrito: "21", nome_distrito: "PONTA DELGADA" },
  { cod_distrito: "12", nome_distrito: "PORTALEGRE" },
  { cod_distrito: "13", nome_distrito: "PORTO" },
  { cod_distrito: "14", nome_distrito: "SANTAREM" },
  { cod_distrito: "15", nome_distrito: "SETUBAL" },
  { cod_distrito: "16", nome_distrito: "VIANA DO CASTELO" },
  { cod_distrito: "17", nome_distrito: "VILA REAL" },
  { cod_distrito: "18", nome_distrito: "VISEU" }
];

export const concelhos = [
  { cod_concelho: "01", nome_concelho: "ABRANTES" },
  { cod_concelho: "01", nome_concelho: "AGUEDA" },
  { cod_concelho: "01", nome_concelho: "AGUIAR DA BEIRA" },
  { cod_concelho: "01", nome_concelho: "ALANDROAL" },
  { cod_concelho: "02", nome_concelho: "ALBERGARIA-A-VELHA" },
  { cod_concelho: "01", nome_concelho: "ALBUFEIRA" },
  { cod_concelho: "01", nome_concelho: "ALCACER DO SAL" },
  { cod_concelho: "02", nome_concelho: "ALCANENA" },
  { cod_concelho: "01", nome_concelho: "ALCOBA\u00c7A" },
  { cod_concelho: "02", nome_concelho: "ALCOCHETE" },
  { cod_concelho: "02", nome_concelho: "ALCOUTIM" },
  { cod_concelho: "01", nome_concelho: "ALENQUER" },
  { cod_concelho: "01", nome_concelho: "ALFANDEGA DA FE" },
  { cod_concelho: "01", nome_concelho: "ALIJO" },
  { cod_concelho: "03", nome_concelho: "ALJEZUR" },
  { cod_concelho: "01", nome_concelho: "ALJUSTREL" },
  { cod_concelho: "03", nome_concelho: "ALMADA" },
  { cod_concelho: "02", nome_concelho: "ALMEIDA" },
  { cod_concelho: "03", nome_concelho: "ALMEIRIM" },
  { cod_concelho: "02", nome_concelho: "ALMODOVAR" },
  { cod_concelho: "04", nome_concelho: "ALPIAR\u00c7A" },
  { cod_concelho: "01", nome_concelho: "ALTER DO CH\u00c3O" },
  { cod_concelho: "02", nome_concelho: "ALVAIAZERE" },
  { cod_concelho: "03", nome_concelho: "ALVITO" },
  { cod_concelho: "15", nome_concelho: "AMADORA" },
  { cod_concelho: "01", nome_concelho: "AMARANTE" },
  { cod_concelho: "01", nome_concelho: "AMARES" },
  { cod_concelho: "03", nome_concelho: "ANADIA" },
  { cod_concelho: "01", nome_concelho: "ANGRA DO HEROISMO" },
  { cod_concelho: "03", nome_concelho: "ANSI\u00c3O" },
  { cod_concelho: "01", nome_concelho: "ARCOS DE VALDEVEZ" },
  { cod_concelho: "01", nome_concelho: "ARGANIL" },
  { cod_concelho: "01", nome_concelho: "ARMAMAR" },
  { cod_concelho: "04", nome_concelho: "AROUCA" },
  { cod_concelho: "02", nome_concelho: "ARRAIOLOS" },
  { cod_concelho: "02", nome_concelho: "ARRONCHES" },
  { cod_concelho: "02", nome_concelho: "ARRUDA DOS VINHOS" },
  { cod_concelho: "05", nome_concelho: "AVEIRO" },
  { cod_concelho: "03", nome_concelho: "AVIS" },
  { cod_concelho: "03", nome_concelho: "AZAMBUJA" },
  { cod_concelho: "02", nome_concelho: "BAI\u00c3O" },
  { cod_concelho: "02", nome_concelho: "BARCELOS" },
  { cod_concelho: "04", nome_concelho: "BARRANCOS" },
  { cod_concelho: "04", nome_concelho: "BARREIRO" },
  { cod_concelho: "04", nome_concelho: "BATALHA" },
  { cod_concelho: "05", nome_concelho: "BEJA" },
  { cod_concelho: "01", nome_concelho: "BELMONTE" },
  { cod_concelho: "05", nome_concelho: "BENAVENTE" },
  { cod_concelho: "05", nome_concelho: "BOMBARRAL" },
  { cod_concelho: "03", nome_concelho: "BORBA" },
  { cod_concelho: "02", nome_concelho: "BOTICAS" },
  { cod_concelho: "03", nome_concelho: "BRAGA" },
  { cod_concelho: "02", nome_concelho: "BRAGAN\u00c7A" },
  { cod_concelho: "04", nome_concelho: "CABECEIRAS DE BASTO" },
  { cod_concelho: "04", nome_concelho: "CADAVAL" },
  { cod_concelho: "06", nome_concelho: "CALDAS DA RAINHA" },
  { cod_concelho: "02", nome_concelho: "CALHETA \\(A\u00c7ORES\\)" },
  { cod_concelho: "01", nome_concelho: "CALHETA \\(MADEIRA\\)" },
  { cod_concelho: "02", nome_concelho: "CAMARA DE LOBOS" },
  { cod_concelho: "02", nome_concelho: "CAMINHA" },
  { cod_concelho: "04", nome_concelho: "CAMPO MAIOR" },
  { cod_concelho: "02", nome_concelho: "CANTANHEDE" },
  { cod_concelho: "03", nome_concelho: "CARRAZEDA DE ANSI\u00c3ES" },
  { cod_concelho: "02", nome_concelho: "CARREGAL DO SAL" },
  { cod_concelho: "06", nome_concelho: "CARTAXO" },
  { cod_concelho: "05", nome_concelho: "CASCAIS" },
  { cod_concelho: "07", nome_concelho: "CASTANHEIRA DE PERA" },
  { cod_concelho: "02", nome_concelho: "CASTELO BRANCO" },
  { cod_concelho: "06", nome_concelho: "CASTELO DE PAIVA" },
  { cod_concelho: "05", nome_concelho: "CASTELO DE VIDE" },
  { cod_concelho: "03", nome_concelho: "CASTRO DAIRE" },
  { cod_concelho: "04", nome_concelho: "CASTRO MARIM" },
  { cod_concelho: "06", nome_concelho: "CASTRO VERDE" },
  { cod_concelho: "03", nome_concelho: "CELORICO DA BEIRA" },
  { cod_concelho: "05", nome_concelho: "CELORICO DE BASTO" },
  { cod_concelho: "07", nome_concelho: "CHAMUSCA" },
  { cod_concelho: "03", nome_concelho: "CHAVES" },
  { cod_concelho: "04", nome_concelho: "CINF\u00c3ES" },
  { cod_concelho: "03", nome_concelho: "COIMBRA" },
  { cod_concelho: "04", nome_concelho: "CONDEIXA-A-NOVA" },
  { cod_concelho: "08", nome_concelho: "CONSTANCIA" },
  { cod_concelho: "09", nome_concelho: "CORUCHE" },
  { cod_concelho: "01", nome_concelho: "CORVO" },
  { cod_concelho: "03", nome_concelho: "COVILH\u00c3" },
  { cod_concelho: "06", nome_concelho: "CRATO" },
  { cod_concelho: "07", nome_concelho: "CUBA" },
  { cod_concelho: "07", nome_concelho: "ELVAS" },
  { cod_concelho: "10", nome_concelho: "ENTRONCAMENTO" },
  { cod_concelho: "07", nome_concelho: "ESPINHO" },
  { cod_concelho: "06", nome_concelho: "ESPOSENDE" },
  { cod_concelho: "08", nome_concelho: "ESTARREJA" },
  { cod_concelho: "04", nome_concelho: "ESTREMOZ" },
  { cod_concelho: "05", nome_concelho: "EVORA" },
  { cod_concelho: "07", nome_concelho: "FAFE" },
  { cod_concelho: "05", nome_concelho: "FARO" },
  { cod_concelho: "03", nome_concelho: "FELGUEIRAS" },
  { cod_concelho: "08", nome_concelho: "FERREIRA DO ALENTEJO" },
  { cod_concelho: "11", nome_concelho: "FERREIRA DO ZEZERE" },
  { cod_concelho: "05", nome_concelho: "FIGUEIRA DA FOZ" },
  { cod_concelho: "04", nome_concelho: "FIGUEIRA DE CASTELO RODRIGO" },
  { cod_concelho: "08", nome_concelho: "FIGUEIRO DOS VINHOS" },
  { cod_concelho: "05", nome_concelho: "FORNOS DE ALGODRES" },
  { cod_concelho: "04", nome_concelho: "FREIXO DE ESPADA A CINTA" },
  { cod_concelho: "08", nome_concelho: "FRONTEIRA" },
  { cod_concelho: "03", nome_concelho: "FUNCHAL" },
  { cod_concelho: "04", nome_concelho: "FUND\u00c3O" },
  { cod_concelho: "09", nome_concelho: "GAVI\u00c3O" },
  { cod_concelho: "06", nome_concelho: "GOIS" },
  { cod_concelho: "12", nome_concelho: "GOLEG\u00c3" },
  { cod_concelho: "04", nome_concelho: "GONDOMAR" },
  { cod_concelho: "06", nome_concelho: "GOUVEIA" },
  { cod_concelho: "05", nome_concelho: "GRANDOLA" },
  { cod_concelho: "07", nome_concelho: "GUARDA" },
  { cod_concelho: "08", nome_concelho: "GUIMAR\u00c3ES" },
  { cod_concelho: "02", nome_concelho: "HORTA" },
  { cod_concelho: "05", nome_concelho: "IDANHA-A-NOVA" },
  { cod_concelho: "10", nome_concelho: "ILHAVO" },
  { cod_concelho: "06", nome_concelho: "LAGOA \\(ALGARVE\\)" },
  { cod_concelho: "01", nome_concelho: "LAGOA \\(A\u00c7ORES\\)" },
  { cod_concelho: "07", nome_concelho: "LAGOS" },
  { cod_concelho: "03", nome_concelho: "LAJES DAS FLORES" },
  { cod_concelho: "04", nome_concelho: "LAJES DO PICO" },
  { cod_concelho: "05", nome_concelho: "LAMEGO" },
  { cod_concelho: "09", nome_concelho: "LEIRIA" },
  { cod_concelho: "06", nome_concelho: "LISBOA" },
  { cod_concelho: "08", nome_concelho: "LOULE" },
  { cod_concelho: "07", nome_concelho: "LOURES" },
  { cod_concelho: "08", nome_concelho: "LOURINH\u00c3" },
  { cod_concelho: "05", nome_concelho: "LOUSADA" },
  { cod_concelho: "07", nome_concelho: "LOUS\u00c3" },
  { cod_concelho: "05", nome_concelho: "MACEDO DE CAVALEIROS" },
  { cod_concelho: "04", nome_concelho: "MACHICO" },
  { cod_concelho: "05", nome_concelho: "MADALENA" },
  { cod_concelho: "09", nome_concelho: "MAFRA" },
  { cod_concelho: "06", nome_concelho: "MAIA" },
  { cod_concelho: "06", nome_concelho: "MANGUALDE" },
  { cod_concelho: "08", nome_concelho: "MANTEIGAS" },
  { cod_concelho: "07", nome_concelho: "MARCO DE CANAVESES" },
  { cod_concelho: "10", nome_concelho: "MARINHA GRANDE" },
  { cod_concelho: "10", nome_concelho: "MARV\u00c3O" },
  { cod_concelho: "08", nome_concelho: "MATOSINHOS" },
  { cod_concelho: "13", nome_concelho: "MA\u00c7\u00c3O" },
  { cod_concelho: "11", nome_concelho: "MEALHADA" },
  { cod_concelho: "09", nome_concelho: "MEDA" },
  { cod_concelho: "03", nome_concelho: "MELGA\u00c7O" },
  { cod_concelho: "09", nome_concelho: "MERTOLA" },
  { cod_concelho: "04", nome_concelho: "MES\u00c3O FRIO" },
  { cod_concelho: "08", nome_concelho: "MIRA" },
  { cod_concelho: "09", nome_concelho: "MIRANDA DO CORVO" },
  { cod_concelho: "06", nome_concelho: "MIRANDA DO DOURO" },
  { cod_concelho: "07", nome_concelho: "MIRANDELA" },
  { cod_concelho: "08", nome_concelho: "MOGADOURO" },
  { cod_concelho: "07", nome_concelho: "MOIMENTA DA BEIRA" },
  { cod_concelho: "06", nome_concelho: "MOITA" },
  { cod_concelho: "09", nome_concelho: "MONCHIQUE" },
  { cod_concelho: "05", nome_concelho: "MONDIM DE BASTO" },
  { cod_concelho: "11", nome_concelho: "MONFORTE" },
  { cod_concelho: "06", nome_concelho: "MONTALEGRE" },
  { cod_concelho: "06", nome_concelho: "MONTEMOR-O-NOVO" },
  { cod_concelho: "10", nome_concelho: "MONTEMOR-O-VELHO" },
  { cod_concelho: "07", nome_concelho: "MONTIJO" },
  { cod_concelho: "04", nome_concelho: "MON\u00c7\u00c3O" },
  { cod_concelho: "07", nome_concelho: "MORA" },
  { cod_concelho: "08", nome_concelho: "MORTAGUA" },
  { cod_concelho: "10", nome_concelho: "MOURA" },
  { cod_concelho: "08", nome_concelho: "MOUR\u00c3O" },
  { cod_concelho: "12", nome_concelho: "MURTOSA" },
  { cod_concelho: "07", nome_concelho: "MUR\u00c7A" },
  { cod_concelho: "11", nome_concelho: "NAZARE" },
  { cod_concelho: "09", nome_concelho: "NELAS" },
  { cod_concelho: "12", nome_concelho: "NISA" },
  { cod_concelho: "02", nome_concelho: "NORDESTE" },
  { cod_concelho: "12", nome_concelho: "OBIDOS" },
  { cod_concelho: "11", nome_concelho: "ODEMIRA" },
  { cod_concelho: "16", nome_concelho: "ODIVELAS" },
  { cod_concelho: "10", nome_concelho: "OEIRAS" },
  { cod_concelho: "06", nome_concelho: "OLEIROS" },
  { cod_concelho: "10", nome_concelho: "OLH\u00c3O" },
  { cod_concelho: "13", nome_concelho: "OLIVEIRA DE AZEMEIS" },
  { cod_concelho: "10", nome_concelho: "OLIVEIRA DE FRADES" },
  { cod_concelho: "14", nome_concelho: "OLIVEIRA DO BAIRRO" },
  { cod_concelho: "11", nome_concelho: "OLIVEIRA DO HOSPITAL" },
  { cod_concelho: "21", nome_concelho: "OUREM" },
  { cod_concelho: "12", nome_concelho: "OURIQUE" },
  { cod_concelho: "15", nome_concelho: "OVAR" },
  { cod_concelho: "08", nome_concelho: "PALMELA" },
  { cod_concelho: "12", nome_concelho: "PAMPILHOSA DA SERRA" },
  { cod_concelho: "10", nome_concelho: "PAREDES" },
  { cod_concelho: "05", nome_concelho: "PAREDES DE COURA" },
  { cod_concelho: "09", nome_concelho: "PA\u00c7OS DE FERREIRA" },
  { cod_concelho: "13", nome_concelho: "PEDROG\u00c3O GRANDE" },
  { cod_concelho: "13", nome_concelho: "PENACOVA" },
  { cod_concelho: "11", nome_concelho: "PENAFIEL" },
  { cod_concelho: "11", nome_concelho: "PENALVA DO CASTELO" },
  { cod_concelho: "07", nome_concelho: "PENAMACOR" },
  { cod_concelho: "12", nome_concelho: "PENEDONO" },
  { cod_concelho: "14", nome_concelho: "PENELA" },
  { cod_concelho: "14", nome_concelho: "PENICHE" },
  { cod_concelho: "08", nome_concelho: "PESO DA REGUA" },
  { cod_concelho: "10", nome_concelho: "PINHEL" },
  { cod_concelho: "15", nome_concelho: "POMBAL" },
  { cod_concelho: "03", nome_concelho: "PONTA DELGADA" },
  { cod_concelho: "05", nome_concelho: "PONTA DO SOL" },
  { cod_concelho: "06", nome_concelho: "PONTE DA BARCA" },
  { cod_concelho: "07", nome_concelho: "PONTE DE LIMA" },
  { cod_concelho: "13", nome_concelho: "PONTE DE SOR" },
  { cod_concelho: "14", nome_concelho: "PORTALEGRE" },
  { cod_concelho: "09", nome_concelho: "PORTEL" },
  { cod_concelho: "11", nome_concelho: "PORTIM\u00c3O" },
  { cod_concelho: "12", nome_concelho: "PORTO" },
  { cod_concelho: "16", nome_concelho: "PORTO DE MOS" },
  { cod_concelho: "06", nome_concelho: "PORTO MONIZ" },
  { cod_concelho: "07", nome_concelho: "PORTO SANTO" },
  { cod_concelho: "09", nome_concelho: "POVOA DE LANHOSO" },
  { cod_concelho: "13", nome_concelho: "POVOA DE VARZIM" },
  { cod_concelho: "04", nome_concelho: "POVOA\u00c7\u00c3O" },
  { cod_concelho: "08", nome_concelho: "PROEN\u00c7A-A-NOVA" },
  { cod_concelho: "10", nome_concelho: "REDONDO" },
  { cod_concelho: "11", nome_concelho: "REGUENGOS DE MONSARAZ" },
  { cod_concelho: "13", nome_concelho: "RESENDE" },
  { cod_concelho: "08", nome_concelho: "RIBEIRA BRAVA" },
  { cod_concelho: "09", nome_concelho: "RIBEIRA DE PENA" },
  { cod_concelho: "05", nome_concelho: "RIBEIRA GRANDE" },
  { cod_concelho: "14", nome_concelho: "RIO MAIOR" },
  { cod_concelho: "12", nome_concelho: "S. BRAS DE ALPORTEL" },
  { cod_concelho: "16", nome_concelho: "S. JO\u00c3O DA MADEIRA" },
  { cod_concelho: "15", nome_concelho: "S. JO\u00c3O DA PESQUEIRA" },
  { cod_concelho: "16", nome_concelho: "S. PEDRO DO SUL" },
  { cod_concelho: "07", nome_concelho: "S. ROQUE DO PICO" },
  { cod_concelho: "11", nome_concelho: "S. VICENTE" },
  { cod_concelho: "10", nome_concelho: "SABROSA" },
  { cod_concelho: "11", nome_concelho: "SABUGAL" },
  { cod_concelho: "15", nome_concelho: "SALVATERRA DE MAGOS" },
  { cod_concelho: "14", nome_concelho: "SANTA COMBA D\u00c3O" },
  { cod_concelho: "09", nome_concelho: "SANTA CRUZ" },
  { cod_concelho: "03", nome_concelho: "SANTA CRUZ DA GRACIOSA" },
  { cod_concelho: "06", nome_concelho: "SANTA CRUZ DAS FLORES" },
  { cod_concelho: "09", nome_concelho: "SANTA MARIA DA FEIRA" },
  { cod_concelho: "11", nome_concelho: "SANTA MARTA DE PENAGUI\u00c3O" },
  { cod_concelho: "10", nome_concelho: "SANTANA" },
  { cod_concelho: "16", nome_concelho: "SANTAREM" },
  { cod_concelho: "09", nome_concelho: "SANTIAGO DO CACEM" },
  { cod_concelho: "14", nome_concelho: "SANTO TIRSO" },
  { cod_concelho: "17", nome_concelho: "SARDOAL" },
  { cod_concelho: "17", nome_concelho: "SAT\u00c3O" },
  { cod_concelho: "12", nome_concelho: "SEIA" },
  { cod_concelho: "10", nome_concelho: "SEIXAL" },
  { cod_concelho: "18", nome_concelho: "SERNANCELHE" },
  { cod_concelho: "13", nome_concelho: "SERPA" },
  { cod_concelho: "09", nome_concelho: "SERT\u00c3" },
  { cod_concelho: "11", nome_concelho: "SESIMBRA" },
  { cod_concelho: "12", nome_concelho: "SETUBAL" },
  { cod_concelho: "17", nome_concelho: "SEVER DO VOUGA" },
  { cod_concelho: "13", nome_concelho: "SILVES" },
  { cod_concelho: "13", nome_concelho: "SINES" },
  { cod_concelho: "11", nome_concelho: "SINTRA" },
  { cod_concelho: "12", nome_concelho: "SOBRAL DE MONTE AGRA\u00c7O" },
  { cod_concelho: "15", nome_concelho: "SOURE" },
  { cod_concelho: "15", nome_concelho: "SOUSEL" },
  { cod_concelho: "16", nome_concelho: "TABUA" },
  { cod_concelho: "19", nome_concelho: "TABUA\u00c7O" },
  { cod_concelho: "20", nome_concelho: "TAROUCA" },
  { cod_concelho: "14", nome_concelho: "TAVIRA" },
  { cod_concelho: "10", nome_concelho: "TERRAS DE BOURO" },
  { cod_concelho: "18", nome_concelho: "TOMAR" },
  { cod_concelho: "21", nome_concelho: "TONDELA" },
  { cod_concelho: "09", nome_concelho: "TORRE DE MONCORVO" },
  { cod_concelho: "19", nome_concelho: "TORRES NOVAS" },
  { cod_concelho: "13", nome_concelho: "TORRES VEDRAS" },
  { cod_concelho: "13", nome_concelho: "TRANCOSO" },
  { cod_concelho: "18", nome_concelho: "TROFA" },
  { cod_concelho: "18", nome_concelho: "VAGOS" },
  { cod_concelho: "19", nome_concelho: "VALE DE CAMBRA" },
  { cod_concelho: "08", nome_concelho: "VALEN\u00c7A" },
  { cod_concelho: "15", nome_concelho: "VALONGO" },
  { cod_concelho: "12", nome_concelho: "VALPA\u00c7OS" },
  { cod_concelho: "04", nome_concelho: "VELAS" },
  { cod_concelho: "12", nome_concelho: "VENDAS NOVAS" },
  { cod_concelho: "13", nome_concelho: "VIANA DO ALENTEJO" },
  { cod_concelho: "09", nome_concelho: "VIANA DO CASTELO" },
  { cod_concelho: "14", nome_concelho: "VIDIGUEIRA" },
  { cod_concelho: "11", nome_concelho: "VIEIRA DO MINHO" },
  { cod_concelho: "10", nome_concelho: "VILA DE REI" },
  { cod_concelho: "15", nome_concelho: "VILA DO BISPO" },
  { cod_concelho: "16", nome_concelho: "VILA DO CONDE" },
  { cod_concelho: "07", nome_concelho: "VILA DO PORTO" },
  { cod_concelho: "10", nome_concelho: "VILA FLOR" },
  { cod_concelho: "14", nome_concelho: "VILA FRANCA DE XIRA" },
  { cod_concelho: "06", nome_concelho: "VILA FRANCA DO CAMPO" },
  { cod_concelho: "20", nome_concelho: "VILA NOVA DA BARQUINHA" },
  { cod_concelho: "10", nome_concelho: "VILA NOVA DE CERVEIRA" },
  { cod_concelho: "12", nome_concelho: "VILA NOVA DE FAMALIC\u00c3O" },
  { cod_concelho: "14", nome_concelho: "VILA NOVA DE FOZ COA" },
  { cod_concelho: "17", nome_concelho: "VILA NOVA DE GAIA" },
  { cod_concelho: "22", nome_concelho: "VILA NOVA DE PAIVA" },
  { cod_concelho: "17", nome_concelho: "VILA NOVA DE POIARES" },
  { cod_concelho: "13", nome_concelho: "VILA POUCA DE AGUIAR" },
  { cod_concelho: "05", nome_concelho: "VILA PRAIA DA VITORIA" },
  { cod_concelho: "14", nome_concelho: "VILA REAL" },
  { cod_concelho: "16", nome_concelho: "VILA REAL DE SANTO ANTONIO" },
  { cod_concelho: "11", nome_concelho: "VILA VELHA DE ROD\u00c3O" },
  { cod_concelho: "13", nome_concelho: "VILA VERDE" },
  { cod_concelho: "14", nome_concelho: "VILA VI\u00c7OSA" },
  { cod_concelho: "11", nome_concelho: "VIMIOSO" },
  { cod_concelho: "12", nome_concelho: "VINHAIS" },
  { cod_concelho: "23", nome_concelho: "VISEU" },
  { cod_concelho: "14", nome_concelho: "VIZELA" },
  { cod_concelho: "24", nome_concelho: "VOUZELA" }
];



// WEBPACK FOOTER //
// ./src/plugins/dist_conc.js